import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

export const MasterCardIcon = ({ height, width }: { height: any; width: any }) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" accessible={false} tabIndex={-1}>
      <Defs>
        <ClipPath id="clip-mastercard">
          <Rect width="32" height="32" accessible={false} tabIndex={-1} />
        </ClipPath>
      </Defs>
      <G id="mastercard" clipPath="url(#clip-mastercard)" accessible={false} tabIndex={-1}>
        <G
          id="mastercard-2_2_"
          data-name="mastercard-2 (2)"
          transform="translate(4 8.473)"
          accessible={false}
          tabIndex={-1}>
          <Path
            id="Path_506"
            data-name="Path 506"
            d="M1929.475,977.508v-.288h-.075l-.087.2-.086-.2h-.075v.288h.053v-.217l.081.187h.055l.081-.188v.217h.053Zm-.476,0v-.239h.1v-.049h-.245v.049h.1v.239H1929Z"
            transform="translate(-1905.707 -965.495)"
            fill="#f79410"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Path_507"
            data-name="Path 507"
            d="M736.2,143.813h-6.49V132.15h6.49Z"
            transform="translate(-720.955 -130.565)"
            fill="#ff5f00"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Path_508"
            data-name="Path 508"
            d="M9.167,7.416A7.4,7.4,0,0,1,12,1.585a7.417,7.417,0,1,0,0,11.663A7.4,7.4,0,0,1,9.167,7.416"
            transform="translate(0 0)"
            fill="#eb001b"
            accessible={false}
            tabIndex={-1}
          />
          <Path
            id="Path_509"
            data-name="Path 509"
            d="M1012.11,7.416a7.417,7.417,0,0,1-12,5.831,7.418,7.418,0,0,0,0-11.663,7.417,7.417,0,0,1,12,5.831"
            transform="translate(-988.11 0)"
            fill="#f79e1b"
            accessible={false}
            tabIndex={-1}
          />
        </G>
      </G>
    </Svg>
  )
}
